import { Pipe, PipeTransform } from '@angular/core';

import * as d3 from 'd3';
import { ZoomConfig } from '../zoom-controls/zoom-controls.component';

@Pipe({ name: 'stroke' })
export class StrokePipe implements PipeTransform {
  transform(value: number, args?: Array<number>): number {
    const strokeScale = d3
      .scaleLinear()
      .domain([ZoomConfig.ZOOM_MIN, ZoomConfig.ZOOM_MAX])
      .range(args ? args : [0.5, 0.1]);

    return strokeScale(value);
  }
}
